import { all, takeLatest, call, put } from 'redux-saga/effects';
import { fetchPoiPackageList, putCustomPOI } from '../../../ooh/plansService';
import {
  fetchPoiPackagesListAction,
  fetchPoiPackagesListFailedAction,
  fetchPoiPackagesListSuccessAction,
  putCustomPOIAction,
  putCustomPOIFailedAction,
  putCustomPOISuccessAction,
} from './poiPackagesList.reducer';

function* getPoiPackagesList({ payload }) {
  try {
    const poiPackagesListResponse = yield call(
      () => fetchPoiPackageList(payload),
      payload
    );
    yield put(fetchPoiPackagesListSuccessAction(poiPackagesListResponse));
  } catch (error) {
    fetchPoiPackagesListFailedAction();
  }
}

function* putCustomPOISaga({ payload }) {
  try {
    const poiPackagesListResponse = yield call(putCustomPOI, payload);
    yield put(putCustomPOISuccessAction(poiPackagesListResponse));
  } catch (error) {
    yield put(putCustomPOIFailedAction(error));
  }
}

export function* poiPackagesListWatcher() {
  yield all([takeLatest(fetchPoiPackagesListAction, getPoiPackagesList)]);
  yield all([takeLatest(putCustomPOIAction, putCustomPOISaga)]);
}
